// extracted by mini-css-extract-plugin
export default {"pdfWrapper":"pdf_pdfWrapper__GlSkI","pdfContainer":"pdf_pdfContainer__-spxr"};